<template>
    <div v-click-outside="onClickOutside">
        <div class="card buildingCard showAllUsers">
            <div class="triangle"></div>
            <div class="card-body showAllUsers-card-body">
                <h5 class="card-title buildingCard-title showAllUsers-title">
                 <span class="iconBeforeTitle">
                    <i class="fas fa-users usersIcon"></i>
                </span>
                    Users in {{building.name}}
                </h5>

                <div class="table-responsive userManagement-table-responsive userManagement-form">
                    <form v-on:submit.prevent>
                        <table class="table userManagement-table">
                            <thead>
                            <template v-if="canUpdateRole">
                                <tr class="table-borderless userManagement-table-bulk-header" v-bind:class="{'invisible': !bulkSelectedLength}">
                                    <td>
                                        <label class="d-block userManagement-form-checkbox">
                                            <input class="userManagement-form-checkbox-input"
                                                   type="checkbox"
                                                   v-bind:value="bulk.selected.length"
                                                   v-bind:checked="bulk.selected.length > 0"
                                                   v-on:click="bulk.selected = [];"
                                            />
                                            <span class="userManagement-form-checkbox-container"><i class="fas fa-minus userManagement-form-checkbox-check" v-bind:class="{'invisible': !bulk.selected.length}"></i></span>
                                        </label>
                                    </td>
                                    <td colspan="2">
                                        {{`${bulk.selected.length} USER${bulk.selected.length === 1 ? '' : 'S'} SELECTED`}}</td>
                                    <td>
                                        <div class="userManagement-form-select-input">
                                            <select class="form-control"
                                                    v-on:keyup.esc="bulk.role.building_role_id=undefined"
                                                    v-on:keyup.enter="bulkUpdateRole(buildingId, bulk.role.building_role_id, bulk.selected, buildingUsers)"
                                                    v-bind:disabled="bulk.role.loading || !bulk.selected.length"
                                                    v-bind:readonly="bulk.role.loading"
                                                    v-bind:class="{ 'changed': bulk.role.building_role_id !== undefined, 'is-invalid': bulk.role.error}"
                                                    v-model="bulk.role.building_role_id" >
                                                <option :value="undefined">BULK UPDATE ROLE</option>
                                                <option v-for="(buildingRole, index) in buildingRoles" :value="buildingRole.id">
                                                    {{buildingRole.display_name}}
                                                </option>
                                            </select>
                                            <span v-bind:class="{'d-none': bulk.role.building_role_id === undefined}" class="userManagement-form-btn-group">
                                            <button type="button"
                                                    class="userManagement-form-btn"
                                                    v-bind:disabled="bulk.role.loading"
                                                    v-on:click="bulkUpdateRole(buildingId, bulk.role.building_role_id, bulk.selected, buildingUsers)">
                                                <span v-bind:class="{'d-none':!bulk.role.loading}" class="spinner-border userManagement-form-btn-loading" role="status">
                                                    <span class="sr-only">Updating...</span>
                                                </span>
                                                <span v-bind:class="{'d-none':bulk.role.loading}">
                                                    <i class="fas fa-check"><span class="sr-only">Update</span></i>
                                                </span>
                                            </button>
                                            <button type="button"
                                                    class="userManagement-form-btn"
                                                    v-bind:disabled="bulk.role.loading"
                                                    v-on:click="bulk.role.building_role_id=undefined"><i class="fas fa-times"></i></button>
                                        </span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="userManagement-form-text-input">
                                            <input type="text" maxlength="32" class="form-control "
                                                   v-bind:disabled="bulk.title.loading || !bulk.selected.length"
                                                   v-bind:readonly="bulk.title.loading"
                                                   v-on:keyup.esc="bulk.title.text=undefined"
                                                   v-on:keyup.enter="bulkUpdateTitle(buildingId, bulk.title.text, bulk.selected, buildingUsers)"
                                                   v-bind:class="{'changed': bulk.title.text, 'is-invalid': bulk.title.error}"
                                                   placeholder="BULK UPDATE TITLE"
                                                   v-model="bulk.title.text"
                                            >
                                            <span v-bind:class="{'d-none': bulk.title.text === undefined}" class="userManagement-form-btn-group">
                                            <button type="button"
                                                    class="userManagement-form-btn"
                                                    v-bind:disabled="bulk.title.loading"
                                                    v-on:click="bulkUpdateTitle(buildingId, bulk.title.text, bulk.selected, buildingUsers)">
                                                <span v-bind:class="{'d-none':!bulk.title.loading}" class="spinner-border userManagement-form-btn-loading" role="status">
                                                    <span class="sr-only">Updating...</span>
                                                </span>
                                                <span v-bind:class="{'d-none':bulk.title.loading}">
                                                    <i class="fas fa-check"><span class="sr-only">Update</span></i>
                                                </span>
                                            </button>
                                            <button type="button"
                                                    class="userManagement-form-btn"
                                                    v-bind:disabled="bulk.title.loading"
                                                    v-on:click="bulk.title.text=undefined"><i class="fas fa-times"></i></button>
                                        </span>
                                        </div>
                                    </td>
                                    <td v-if="canRemove" class="userManagement-table-col-remove">
                                        <a v-if="bulk.selected.length" href="javascript:void(0)" v-on:click="bulkDeleteConfirmModal(buildingId, bulk.selected)">BULK REMOVE</a>
                                        <span v-else>BULK REMOVE</span>
                                    </td>
                                </tr>
                            </template>
                            <tr class="userManagement-table-header">
                                <th v-if="canUpdateRole"></th>
                                <th colspan="2">Name</th>
                                <th class="userManagement-table-header-role userManagement-table-header-input">Role</th>
                                <th class="userManagement-table-header-title userManagement-table-header-input">Title</th>
                                <th class="userManagement-table-header-remove userManagement-table-col-remove" v-if="canRemove"></th>
                            </tr>
                            </thead>
                            <tbody>
                            <template v-for="(buildingAccess, index) in buildingUsers">
                            <tr v-if="canUpdateRole || buildingAccess.user.id !== null">
                                <td v-if="canUpdateRole">
                                    <label class="d-block userManagement-form-checkbox" v-if="canUpdateRoleMethod(buildingAccess.user)">
                                        <input class="userManagement-form-checkbox-input"
                                               type="checkbox"
                                               v-bind:value="buildingAccess.user.email"
                                               v-model="bulk.selected"/>
                                        <span class="userManagement-form-checkbox-container"><i class="fas fa-check userManagement-form-checkbox-check" v-bind:class="{'invisible': bulk.selected.indexOf(buildingAccess.user.email) < 0}"></i></span>
                                    </label>
                                </td>
                                <td>
                                    <div class="showRoleRelatedUsers"
                                         v-bind:class="{'showRoleRelatedUsersSelf': buildingAccess.user.uuid && buildingAccess.user.uuid === $store.getters.firebaseUser.uid}"
                                    >{{buildingAccess.user.userInitial}}</div>
                                </td>
                                <td>
                                    <div class="textBlock-desc-main">{{buildingAccess.user.name}}</div>
                                    <div class="textBlock-desc-sub" v-if="canUpdateRole || buildingAccess.user.uuid === $store.getters.firebaseUser.uid">{{buildingAccess.user.email}}</div>
                                </td>
                                <td>
                                    <div class="userManagement-form-select-input">
                                        <select class="form-control"
                                                v-on:keyup.esc="resetRole(buildingAccess)"
                                                v-on:keyup.enter="singleUpdateRole(buildingId, buildingAccess)"
                                                v-bind:disabled="!canUpdateRoleMethod(buildingAccess.user) || single.role.loading.indexOf(buildingAccess.user.email) > -1"
                                                v-bind:readonly="single.role.loading.indexOf(buildingAccess.user.email) > -1"
                                                v-bind:class="{ 'changed': single.role.changed.indexOf(buildingAccess.user.email) > -1, 'is-invalid': single.role.error.indexOf(buildingAccess.user.email) > -1}"
                                                v-on:change="tools.addEl(buildingAccess.user.email, single.role.changed);tools.removeEl(buildingAccess.user.email, single.role.error);"
                                                v-model="buildingAccess.building_role.id" >
                                            <option v-for="(buildingRole, index) in buildingRoles" :value="buildingRole.id">
                                                {{buildingRole.display_name}}
                                            </option>
                                        </select>
                                        <span v-bind:class="{'d-none':single.role.changed.indexOf(buildingAccess.user.email) < 0 }" class="userManagement-form-btn-group">
                                            <button type="button"
                                                    class="userManagement-form-btn"
                                                    v-bind:disabled="single.role.loading.indexOf(buildingAccess.user.email) > -1"
                                                    v-on:click="singleUpdateRole(buildingId, buildingAccess)">
                                                <span v-bind:class="{'d-none':single.role.loading.indexOf(buildingAccess.user.email) < 0}" class="spinner-border userManagement-form-btn-loading" role="status">
                                                    <span class="sr-only">Updating...</span>
                                                </span>
                                                <span v-bind:class="{'d-none':single.role.loading.indexOf(buildingAccess.user.email) > -1}">
                                                    <i class="fas fa-check"><span class="sr-only">Update</span></i>
                                                </span>
                                            </button>
                                            <button type="button"
                                                    class="userManagement-form-btn"
                                                    v-bind:disabled="single.role.loading.indexOf(buildingAccess.user.email) > -1"
                                                    v-on:click="resetRole(buildingAccess)"><i class="fas fa-times"></i></button>
                                        </span>
                                    </div>
                                </td>
                                <td>
                                    <div class="userManagement-form-text-input">
                                        <input type="text" maxlength="32" class="form-control"
                                               v-bind:disabled="!canUpdateTitleMethod(buildingAccess.user) || single.title.loading.indexOf(buildingAccess.user.email) > -1"
                                               v-bind:readonly="single.title.loading.indexOf(buildingAccess.user.email) > -1"
                                               v-on:keydown="tools.addEl(buildingAccess.user.email, single.title.changed);tools.removeEl(buildingAccess.user.email, single.title.error);"
                                               v-on:keyup.esc="resetTitle(buildingAccess)"
                                               v-on:keyup.enter="singleUpdateTitle(buildingId, buildingAccess)"
                                               v-bind:class="{'changed': single.title.changed.indexOf(buildingAccess.user.email) > -1, 'is-invalid': single.title.error.indexOf(buildingAccess.user.email) > -1}"
                                               placeholder="N/A"
                                               v-model="buildingAccess.title"
                                        />
                                        <span v-bind:class="{'d-none':single.title.changed.indexOf(buildingAccess.user.email) < 0}" class="userManagement-form-btn-group">
                                            <button type="button"
                                                    class="userManagement-form-btn"
                                                    v-bind:disabled="single.title.loading.indexOf(buildingAccess.user.email) > -1"
                                                    v-on:click="singleUpdateTitle(buildingId, buildingAccess)">
                                                <span v-bind:class="{'d-none':single.title.loading.indexOf(buildingAccess.user.email) < 0}" class="spinner-border userManagement-form-btn-loading" role="status">
                                                    <span class="sr-only">Updating...</span>
                                                </span>
                                                <span v-bind:class="{'d-none':single.title.loading.indexOf(buildingAccess.user.email) > -1}">
                                                    <i class="fas fa-check"><span class="sr-only">Update</span></i>
                                                </span>
                                            </button>
                                            <button type="button"
                                                    class="userManagement-form-btn"
                                                    v-bind:disabled="single.title.loading.indexOf(buildingAccess.user.email) > -1"
                                                    v-on:click="resetTitle(buildingAccess)"><i class="fas fa-times"></i></button>
                                        </span>
                                    </div>
                                </td>
                                <td class="userManagement-table-col-remove" v-if="canRemove">
                                    <template v-if="canRemoveMethod(buildingAccess.user)">
                                        <button type="button" class="btn float-right btn-sm"
                                                v-on:click="deleteConfirmModal(buildingId, buildingAccess)">Remove
                                        </button>
                                    </template>
                                </td>
                            </tr>
                            </template>
                            </tbody>
                        </table>
                    </form>
                </div>
            </div>
        </div>

        <InfoModalComponent
                v-if="dataToPassToInfoModal.showModal"
                :confirm="dataToPassToInfoModal"
                @close="dataToPassToInfoModal.showModal = false;"
        ></InfoModalComponent>

        <DeleteModalComponent
                v-if="deleteModal.showModal"
                @delete="removeSingle(deleteModal.buildingId, deleteModal.buildingAccess)"
                @close="deleteModal.showModal = false"
                :confirm="deleteModal.confirm">
        </DeleteModalComponent>

        <DeleteModalComponent
                v-if="bulkDeleteModal.showModal"
                @delete="bulkRemoveRole(bulkDeleteModal.buildingId, bulkDeleteModal.selected)"
                @close="bulkDeleteModal.showModal = false"
                :confirm="bulkDeleteModal.confirm">
        </DeleteModalComponent>
    </div>
</template>
<style lang="scss" scoped>

</style>
<script>
  import InfoModalComponent from '@/components/modal/InfoComponent.vue';
  import DeleteModalComponent from '@/components/modal/DeleteModalComponent.vue';
  import Tools from '@/app-model/tools.js';
  import User from '@/app-model/user.js';
  import vClickOutside from 'v-click-outside'

  export default {
    props: {
      buildingId: [String, Number],
      users: [Array, Object],
      buildingRoles: Array,
    },

    directives: {
      clickOutside: vClickOutside.directive
    },

    data () {
      return {
        bulk: {
          selected: [],
          role: {
            building_role_id: undefined,
            loading: false,
            error: false,
          },
          title: {
            text: undefined,
            loading: false,
            error: false,
          },
          remove: {
            loading: false,
            error: false,
          },
        },
        single: {
          role: {
            changed: [],
            loading: [],
            error: [],
          },
          title: {
            changed: [],
            loading: [],
            error: [],
          },
          remove: {
            loading: [],
            error: [],
          },
        },

        buildingUsers: JSON.parse(JSON.stringify(this.users)),

        dataToPassToInfoModal: {
          showModal: false,
          success: false,
          title: '',
          msg: '',
        },
        deleteModal: {
          showModal: false,
          buildingId: 0,
          buildingAccess: {},
          confirm: {
            title: '',
            msg: ''
          }
        },
        bulkDeleteModal: {
          showModal: false,
          buildingId: 0,
          selected: [],
          confirm: {
            title: '',
            msg: ''
          }
        },
      }
    },
    components: {
      InfoModalComponent,
      DeleteModalComponent,
    },

    created() {

    },
    methods: {
      onClickOutside () {
        this.$emit('close')
      },
      canUpdateRoleMethod (user) {
        return this.userModel.canUpdateUserBuildingRoleToUser({store: this.$store, user}, this.canUpdateRole);
      },
      canUpdateTitleMethod (user) {
        return this.userModel.canUpdateUserBuildingTitleToUser({store: this.$store, user}, this.canUpdateTitle);
      },
      canRemoveMethod (user) {
        return this.userModel.canRemoveUserBuildingRoleToUser({store: this.$store, user}, this.canRemove);
      },
      resetRole(buildingAccess) {
        let sourceUser = this.users.find(el => el.user.email === buildingAccess.user.email);
        buildingAccess.building_role.id = sourceUser.building_role.id;
        this.tools.removeEl(buildingAccess.user.email, this.single.role.changed);
      },
      resetTitle(buildingAccess) {
        let sourceUser = this.users.find(el => el.user.email === buildingAccess.user.email);
        buildingAccess.title = sourceUser.title;
        this.tools.removeEl(buildingAccess.user.email, this.single.title.changed);
      },
      deleteConfirmModal: function (buildingId, buildingAccess) {
        this.deleteModal.showModal = true;
        this.deleteModal.confirm.title = 'Are you sure you want to remove this user?';
        this.deleteModal.confirm.msg = 'This action will remove the user from the building';
        this.deleteModal.buildingId = buildingId;
        this.deleteModal.buildingAccess = buildingAccess;
      },

      singleUpdateTitle: function (buildingId, buildingAccess) {
        return this.updateTitle(buildingId, buildingAccess).then(response => response.status !== 200 || this.$emit('updateUsers'));
      },

      updateTitle: async function (buildingId, buildingAccess) {
        this.tools.removeEl(buildingAccess.user.email, this.single.title.error);
        this.tools.addEl(buildingAccess.user.email, this.single.title.loading);

        return this.userModel.updateUserBuildingTitle(
          {
            store: this.$store,
            buildingId
          },
          buildingAccess.user.id,
          buildingAccess.title
        ).then(response => {
          this.tools.removeEl(buildingAccess.user.email, this.single.title.loading);
          if (buildingId === this.buildingId) {
            switch (response.status) {
              case 401:
              case 410:
              case 422:
                this.tools.addEl(buildingAccess.user.email, this.single.title.error);
                break;
              case 200:
                this.tools.removeEl(buildingAccess.user.email, this.single.title.changed);
                break;
            }
          }
          return response;
        });
      },

      singleUpdateRole: function (buildingId, buildingAccess) {
        return this.updateRole(buildingId, buildingAccess).then(response => response.status !== 200 || this.$emit('updateUsers'));
      },

      updateRole: function (buildingId, buildingAccess) {
        this.tools.removeEl(buildingAccess.user.email, this.single.role.error);
        this.tools.addEl(buildingAccess.user.email, this.single.role.loading);

        return this.userModel.updateUserBuildingRole(
          {
            store: this.$store,
            buildingId
          },
          buildingAccess.user.id,
          buildingAccess.building_role.id
        ).then(response => {
          this.tools.removeEl(buildingAccess.user.email, this.single.role.loading);
          if (buildingId === this.buildingId) {
            switch (response.status) {
              case 401:
              case 410:
              case 422:
                this.tools.addEl(buildingAccess.user.email, this.single.role.error);
                break;
              case 200:
                this.tools.removeEl(buildingAccess.user.email, this.single.role.changed);
                break;
            }
          }
          return response;
        });
      },

      removeSingle: function (buildingId, buildingAccess) {
        return this.removeRole(buildingId, buildingAccess).then(response => {
          this.deleteModal.showModal = false;
          if(buildingId === this.buildingId) {
            switch (response.status) {
              case 200:
                this.dataToPassToInfoModal.showModal = true;
                this.dataToPassToInfoModal.success = true;
                this.dataToPassToInfoModal.title = 'Removed successfully';
                this.dataToPassToInfoModal.msg = 'User has been removed from the building';
                break;
              case 401:
              case 410:
              case 422:
                this.dataToPassToInfoModal.showModal = true;
                this.dataToPassToInfoModal.success = false;
                this.dataToPassToInfoModal.title = 'Error';
                this.dataToPassToInfoModal.msg = response.data.message;
                break;
            }

            this.$emit('updateUsers');
          }
        });
      },

      removeRole: function (buildingId, buildingAccess) {
        this.tools.addEl(buildingAccess.user.email, this.single.remove.loading);
        return this.userModel.removeUserBuildingRole(
          {
            store: this.$store,
            buildingId
          },
          buildingAccess.user.id
        ).then(response => {
          this.tools.removeEl(buildingAccess.user.email, this.single.remove.loading);
          if (buildingId === this.buildingId) {
            switch (response.status) {
              case 200:
                let i = this.buildingUsers.findIndex(el => el.user.email == buildingAccess.user.email);
                if (i > -1) {
                  this.buildingUsers.splice(i, 1);
                }
                let j = this.bulk.selected.indexOf(buildingAccess.user.email);
                if (j > -1) {
                  this.bulk.selected.splice(j, 1);
                }
                break;
              case 401:
              case 410:
              case 422:
                break;
            }
          }
          return response;
        });
      },

      bulkUpdateRole: async function (buildingId, buildingRoleId, selected, buildingUsers) {
        this.bulk.role.loading = true;
        let promises = [];
        for (let i = 0; i < buildingUsers.length; i++) {
          let buildingAccess = buildingUsers[i];
          if(selected.indexOf(buildingAccess.user.email) > -1 && this.canUpdateRoleMethod(buildingAccess.user)) {
            buildingAccess.building_role.id = buildingRoleId;
            promises.push(this.updateRole(buildingId, buildingAccess));
          }
        }
        await Promise.all(promises).then(response => {this.$emit('updateUsers');});
        this.bulk.role.loading = false;
        this.bulk.role.building_role_id = undefined;
      },

      bulkUpdateTitle: async function (buildingId, title, selected, buildingUsers) {
        this.bulk.title.loading = true;
        let promises = [];
        for (let i = 0; i < buildingUsers.length; i++) {
          let buildingAccess = buildingUsers[i];
          if(selected.indexOf(buildingAccess.user.email) > -1 && this.canUpdateTitleMethod(buildingAccess.user)) {
            buildingAccess.title = title;
            promises.push(this.updateTitle(buildingId, buildingAccess));
          }
        }
        await Promise.all(promises).then(response => {this.$emit('updateUsers');});
        this.bulk.title.loading = false;
        this.bulk.title.text = undefined;
      },

      bulkDeleteConfirmModal: function (buildingId, selected) {
        this.bulkDeleteModal.showModal = true;
        this.bulkDeleteModal.confirm.title = `Are you sure you want to remove ${selected.length > 1 ? 'these' : 'the'} user${selected.length > 1 ? 's' : ''}?`;
        this.bulkDeleteModal.confirm.msg = `This action will remove ${selected.length} user${selected.length > 1 ? 's' : ''} from this building.`;
        this.bulkDeleteModal.buildingId = buildingId;
        this.bulkDeleteModal.selected = selected;
      },

      bulkRemoveRole: async function (buildingId, selected) {
        this.bulk.remove.loading = true;
        let promises = [];
        for (let i = 0; i < this.buildingUsers.length; i++) {
          let buildingAccess = this.buildingUsers[i];
          if(selected.indexOf(buildingAccess.user.email) > -1 && this.canRemoveMethod(buildingAccess.user)) {
            promises.push(this.removeRole(buildingId, buildingAccess));
          }
        }

        await Promise.all(promises).then(responses => {
          this.bulkDeleteModal.showModal = false;
          if(buildingId === this.buildingId) {
            let msg = [], total = responses.length;
            for(let i = 0; i < total; i++) {
              let response = responses[i];
              if (response.status !== 200) {
                msg.push([response.data.message]);
              }
            }

            this.dataToPassToInfoModal.showModal = true;

            if (msg.length > 0) {
              this.dataToPassToInfoModal.success = false;
              this.dataToPassToInfoModal.title = 'Error';
              this.dataToPassToInfoModal.msg = msg;
            }
            else {
              this.dataToPassToInfoModal.success = true;
              this.dataToPassToInfoModal.title = `Removed successfully`;
              this.dataToPassToInfoModal.msg = `${total} ${total > 1 ? 'users have ' : 'user has'} been removed from the building`;
            }

            this.$emit('updateUsers');
          }
        });
        this.bulk.remove.loading = false;
      },
    },
    computed: {
      tools: function() {
        return new Tools;
      },
      userModel: function() {
        return new User;
      },
      building: function() {
        return this.$store.getters.building({buildingId: this.buildingId});
      },
      canUpdateRole () {
        return this.userModel.canUpdateUserBuildingRole({store: this.$store, buildingId: this.buildingId});
      },
      canUpdateTitle () {
        return this.userModel.canUpdateUserBuildingTitle({store: this.$store, buildingId: this.buildingId});
      },
      canRemove () {
        return this.userModel.canRemoveUserBuildingRole({store: this.$store, buildingId: this.buildingId});
      },
      bulkSelectedLength: function() {
        if(!this.bulk.selected.length) {
          this.bulk.role.building_role_id = undefined;
          this.bulk.title.text = undefined;
        }
        return this.bulk.selected.length;
      },
    }
  }
</script>
<style lang="scss" scoped>
    @import "@/../sass/_building_card.scss";
    @import "@/../sass/_users.scss";
</style>